<div class="example-container-ri" cdkDropListGroup>
  <div cdkDropList (cdkDropListEntered)="onDropListEntered($event)" (cdkDropListDropped)="onDropListDropped()"></div>
  @for (item of items; track item) {
    <div class="example-boundary" cdkDropList (cdkDropListEntered)="onDropListEntered($event)"
      (cdkDropListDropped)="onDropListDropped()">
      <div cdkDrag class="example-box">
        <div [class]="configuration.imagePositionClass">
          @if (item.imageUrl) {
            <div [class]="configuration.imageClass ?? ''">
              <img [class]="configuration.imageTagClass" [attr.src]="item.imageUrl" [attr.alt]="item.imageFileName" />
            </div>
          }
        </div>
        <div class="d-flex flex-column text-center">
          <div class="mt-1">
            @if (item.title) {
              <h2 class="dark-red mt-2">
                {{ item.title }}
              </h2>
            }
            @if (item.name) {
              <p><b>{{ item.file }}</b></p>
            }
            @if (item.fileDisplayName) {
              <p><b>{{ item.fileDisplayName }}</b></p>
            }
            @if (item.name) {
              <p><b>{{ item.name }}</b></p>
            }
            @if (item.position) {
              <p>{{ item.position }}</p>
            }
            @if (item.email) {
              <p>{{ item.email }}</p>
            }
            @if (item.businessOrgName) {
              <p>{{ item.businessOrgName }}</p>
            }
            @if (item.location) {
              <p>{{ item.location }}</p>
            }
            @if (item.startDate) {
              <p class="date-color pt-2">
                {{ item.startDate | date: 'short' }}@if (item.endDate) {
                <span> - </span>
              }
            </p>
          }
          @if (item.endDate) {
            <p>
              <b>{{ item.endDate | date: 'short' }}</b>
            </p>
          }
          @if (item.registrationLinkText) {
            <p class="pt-2">
              <b>{{ item.registrationLinkText }}</b>
            </p>
          }
          @if (item.publishDate) {
            <p class="date-color pt-2">
              {{ item.publishDate | date: 'short' }}
            </p>
          }
          @if (item.tagSelections && item.tagSelections.length > 0) {
            <div>
              <p>Tags:</p>
              <ul>
                @for (tagSelection of item.tagSelections; track tagSelection) {
                  <li>
                    {{ tagSelection.tagName }}
                  </li>
                }
              </ul>
            </div>
          }
        </div>
      </div>
      <div class="mt-auto">
        <div class="d-flex flex-row justify-content-center">
          @if (item.hrefText) {
            <a class="btn btn-danger btn-block btn-sm my-3" href="{{ item.hrefText }}"
              target="_blank">
              {{ item.hrefText }}
            </a>
          }
          @if (item.resgistrationUrl) {
            <a class="btn btn-danger btn-block btn-sm my-3"
              href="{{ item.resgistrationUrl }}" target="_blank">
              {{ item.resgistrationUrl }}
            </a>
          }
          @if (item.flyerUrl) {
            <a class="btn btn-danger btn-block btn-sm flyer-url my-3" href="{{ item.flyerUrl }}"
              target="_blank">
              {{ item.flyerUrl }}
            </a>
          }
          @if (item.virtualUrl) {
            <a class="btn btn-danger btn-block btn-sm my-3" href="{{ item.virtualUrl }}"
              target="_blank">
              {{ item.virtualUrl }}
            </a>
          }
        </div>
        <div class="d-flex justify-content-between">
          <i class="icon" [ngClass]="{'d-none': !isEditable && !configuration.editable}" (click)="performEditAction(item)">
            <fa-icon [icon]="faEdit"></fa-icon>
          </i>
          <i class="icon" (click)="deleteIconClick.emit(item)">
            <fa-icon [icon]="faTrash"></fa-icon>
          </i>
        </div>
      </div>
    </div>
  </div>
}
</div>
